<template>
    <div class="head-container">
        <div class="logo-container">
            <img src="@/assets/logo.png" alt="">
        </div>
        <div class="d-none">
            <router-link v-slot="{ href }" to="/Συχνές Ερωτήσεις.pdf" target="_blank">
                <a :href="href">
                    <span class="instructions-btn">{{ $t('headerBar.instructions') }} </span>
                </a>
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
    .head-container {
        width: 100%;
        margin: 0 auto;
        padding: 1rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .logo-container img{
        width: 46%;
        height: auto;
    }
    .instructions-btn {
        margin-right: .5rem;
        text-align: center;
        background: #fff;
        font-size: 1.05rem;
        padding: 5px 10px;
        border-radius: 4px;
        box-shadow: 0px 3px 6px #00000029;
        cursor: pointer;
        color: #212529;
    }
    a:hover {
        text-decoration: none;
    }
    @media screen and (min-width: 1150px) {
        .head-container {
            padding: 1rem 0;
        }
    }
    @media screen and (max-width: 700px) {
        .logo-container img {
            width: 25%;
        }
        .head-container {
            width: 100%;
        }
        .instructions-btn {
            margin-left: 0rem;
            font-size: .8rem;
            flex-grow: 1;
        }
        .head-container div:last-child {
            flex-shrink: 0;
        }
    }
</style>
